export default __webpack_public_path__ + "static/media/fc_sale_bg.bebbc37f.png";